import React from "react";
//Icons
import { ArrowLeftOutlined } from "@ant-design/icons";

export const ReplyMessage = ({onClick}: any) => (
  <span className="pointerCursor" onClick={onClick}><ArrowLeftOutlined/> Reply</span>
)